import { cn } from '@seen/ui'
import { IconUserCircle } from '@tabler/icons-react'
import type { JSX } from 'react'

export function IconUserPlaceholder({
  className,
}: {
  className?: string
}): JSX.Element {
  return (
    <IconUserCircle className={cn('size-5 stroke-[1.5] p-0.5', className)} />
  )
}
